
export class downloadExpressInvoiceRequest {
  bookingNo?: string;

  constructor() {
    this.bookingNo = undefined;
  }
}
